module.exports = __webpack_public_path__ + "img/thumb-collection-escritorio.103a179f.jpeg";